<template>
  <OwnStack
    v-if="isVisible"
    class="own-dialog"
    justify="center"
    align="center"
    @click.stop="onCancel"
  >
    <OwnCard class="own-dialog__card" @click.stop>
      <slot name="full-dialog">
        <slot name="heading" :close="closeDialog"></slot>
        <slot :close="closeDialog"></slot>
        <slot name="footer" :close="closeDialog"></slot>
      </slot>
    </OwnCard>
  </OwnStack>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core'
import { WritableComputedRef } from 'vue'

import { OwnCard } from '../OwnCard'
import { OwnStack } from '../OwnStack'

const props = withDefaults(
  defineProps<{
    value?: boolean
  }>(),
  {
    value: false,
  }
)

const emit = defineEmits(['cancel'])

const isVisible = useVModel(props) as WritableComputedRef<boolean>

const closeDialog = () => {
  isVisible.value = false
}
const onCancel = () => {
  emit('cancel')
  closeDialog()
}
</script>

<style lang="scss">
.own-dialog {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 300;

  margin: 0;
  background-color: rgba(0, 0, 0, 0.89);

  padding: 16px;

  &__card {
    width: 100%;
    max-height: calc(100% - 80px);

    @include respond-to('md-and-up') {
      width: 600px;
    }
  }

  &__close {
    width: 20px;
    height: 20px;
  }
}
</style>
